import { TeamId, PlayerId, ChecklistItemId, ChecklistItemStatus } from "@ollie-sports/models";
import { getUniversalHelpers } from "../../helpers";

export async function checklistItem__client__updateChecklistItemTitle(p: { checklistItemId: ChecklistItemId; title: string }) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  await h.ChecklistItem.update({ id: p.checklistItemId, doc: { title: p.title } });
}

// i18n certified - complete
